import _ from "lodash"
import getInstance from "../../../../../i18n/IntlInstance"
import { colors } from "./theme"
import { common } from "./styles"
import messages from "./messages"

function getResponsiveStyle() {
  // this is 5 iPhone width
  if (window.innerWidth <= 320) {
    return {
      spacing: 4,
      padding: 4,
      width: 52,
      fontSize: common.xsFontSize
    }
  }
  // this is 6/7/8 iPhone width
  if (window.innerWidth <= 375) {
    return {
      spacing: 4,
      padding: 4,
      width: 52,
      fontSize: common.xsFontSize
    }
  }
  if (window.innerWidth <= 680) {
    return {
      spacing: 4,
      padding: 4,
      width: 60,
      fontSize: common.sFontSize
    }
  }
  // this is Material-ui SM breakpoints
  if (window.innerWidth <= 840) {
    return {
      spacing: 4,
      padding: 4,
      width: 90,
      fontSize: common.mFontSize
    }
  }
  return {
    spacing: 5,
    padding: 6,
    width: 120,
    fontSize: common.mFontSize
  }
}

/**
 *
 * This is a hook to translate button text value generated from JUMP Backend API.
 *
 * button.type possible values are: `millisecond`, `second`, `minute`, `hour`, `day`, `week`, `month`, `year`, `ytd`, and `all`
 * See API docs:
 * @see Highcharts.RangeSelectorButtonTypeValue
 * @apioption  rangeSelector.buttons.type
 */
function translateRangeSelectorButtons(buttons) {
  if (_.isEmpty(buttons)) {
    return buttons
  }

  const intl = getInstance()
  return buttons.map((button) => {
    let intlMessage = messages[button.type]
    if (!intlMessage) return button
    if (intlMessage.id === "word.chart.year" && button.count === 1) {
      // "1 year(s)" -> "1 year"
      intlMessage = messages.oneYear
    }
    return {
      ...button,
      text: intl.formatMessage(intlMessage, { count: button.count })
    }
  })
}

/**
 * Custom range selectors
 * See: com.jump.server.web.pattern.chart.highcharts.HighchartsRangeSelectorOption
 * See: https://www.highcharts.com/docs/stock/range-selector
 * See API docs: https://api.highcharts.com/highstock/rangeSelector
 * @param chartOpts
 * @returns {*}
 */
export default function rangeSelectorPlugin(chartOpts, chart) {
  if (!chartOpts.rangeSelector) {
    return chartOpts
  }

  // _.unset(chartOpts, "rangeSelector.buttonPosition")
  _.unset(chartOpts, "rangeSelector.inputPosition")

  const setChangesOnChart = (path, value) => {
    _.set(chartOpts, path, value)
    if (!chart || _.get(chart, `options.${path}`) === value) {
      return
    }
    chart.update(chartOpts)
  }

  // translate button
  // this is customer requirement
  // Hard coded selected range for current customer
  const buttonsArr = [
    {
      type: "ytd",
      text: "YTD",
      events: {
        click: () =>
          setChangesOnChart("plotOptions.series.custom.creation", false)
      }
    },
    {
      type: "month",
      count: 1,
      events: {
        click: () =>
          setChangesOnChart("plotOptions.series.custom.creation", false)
      }
    },
    {
      type: "month",
      count: 6,
      events: {
        click: () =>
          setChangesOnChart("plotOptions.series.custom.creation", false)
      }
    },
    {
      type: "year",
      count: 1,
      events: {
        click: () =>
          setChangesOnChart("plotOptions.series.custom.creation", false)
      }
    },
    {
      type: "year",
      count: 3,
      events: {
        click: () =>
          setChangesOnChart("plotOptions.series.custom.creation", false)
      }
    },
    {
      type: "all",
      events: {
        click: () =>
          setChangesOnChart("plotOptions.series.custom.creation", true)
      }
    }
  ]
  const buttons = translateRangeSelectorButtons(buttonsArr)
  _.set(chartOpts, "rangeSelector.buttons", buttons)
  // do not let Highcharts disable buttons based on a mysterious heuristic
  _.set(chartOpts, "rangeSelector.allButtonsEnabled", true)
  _.set(chartOpts, "rangeSelector.labelStyle.display", "none")
  _.set(chartOpts, "rangeSelector.x", 0)
  _.set(chartOpts, "rangeSelector.y", 0)

  _.set(chartOpts, "rangeSelector.buttonPosition", {
    align: "right",
    x: 0,
    y: 0
  })

  const responsive = getResponsiveStyle()

  // never suggest a dropdown menu when screen is too small
  _.set(chartOpts, "rangeSelector.dropdown", "responsive")
  _.set(chartOpts, "rangeSelector.buttonSpacing", responsive.spacing)
  _.set(chartOpts, "rangeSelector.buttonTheme.padding", responsive.padding)
  _.set(chartOpts, "rangeSelector.buttonTheme.width", responsive.width)
  _.set(chartOpts, "rangeSelector.buttonTheme.stroke", colors.darkBlue)
  _.set(chartOpts, "rangeSelector.buttonTheme.stroke-width", 1)
  _.set(chartOpts, "xAxis.highstock", true)

  const style = {
    color: common.blue,
    fontSize: responsive.fontSize,
    fontFamily: common.fontFamily
  }
  _.set(chartOpts, "rangeSelector.buttonTheme.style", style)
  //
  // // custom states
  const states = {
    hover: {
      fill: common.blue,
      style: {
        color: colors.white
      }
    },
    select: {
      fill: common.blue,
      style: {
        color: colors.white
      }
    }
  }
  _.set(chartOpts, "rangeSelector.buttonTheme.states", states)
  return chartOpts
}
